// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"styles-module--iconWrapper--24lCN","down":"styles-module--down--3TTmX","left":"styles-module--left--3CNuf","up":"styles-module--up--3y7gI"};